import { Settings, Task, PriceCheck, MapsHomeWork, AddHomeWork, ReceiptLong, Description, Assignment } from "@mui/icons-material";

const icons = {
    Settings, Task, PriceCheck, MapsHomeWork, AddHomeWork, ReceiptLong, Description, Assignment
}

// ==============================|| ADMIN PAGES MENU ITEMS ||============================== //

const inmuebles = {
    id: 'inmuebles',
    type: 'group',
    children: [
        {
            id: 'inmuebles-menu',
            title: 'Inmuebles',
            type: 'collapse',
            icon: icons.MapsHomeWork,

            children: [
                {
                    id: 'inmueblesDisponibles',
                    title: 'Inmuebles Disponibles',
                    requiredPermission: 'Inmuebles Disp.',
                    type: 'item',
                    icon: icons.AddHomeWork,
                    url: '/inmuebles/inmueblesDisponibles',
                    target: false
                },
                {
                    id: 'edosCuentaContratos',
                    title: 'Edos. Cta. Contratos',
                    requiredPermission: 'Edos. Cta. Contratos',
                    type: 'item',
                    icon: icons.ReceiptLong,
                    url: '/inmuebles/edos-cuenta-contratos',
                    target: false
                },
            ]
        },
        {
            id: 'contratos-menu',
            title: 'Contratos',
            type: 'collapse',
            icon: icons.Description,

            children: [
                {
                    id: 'crearContrato',
                    title: 'Crear Contrato',
                    requiredPermission: 'Contrato Nuevo',
                    type: 'item',
                    icon: icons.Assignment,
                    url: '/contratos/crear',
                    target: false
                },
                {
                    id: 'apartados',
                    title: 'Apartados',
                    requiredPermission: 'Apartado',
                    type: 'item',
                    icon: icons.AddHomeWork,
                    url: '/contratos/apartados',
                    target: false
                },
            ]
        }
    ]
};

export default inmuebles;
